import { message } from 'antd';
/**
 * @author: leroy
 * @date: 2021/11/3 11:22
 * @description：Home
 */
import { makeAutoObservable, runInAction } from 'mobx';
import { getExamOrder, getOrderList } from '@/store/services/exam';

export class ExamStore {
  isCodeMonitor: boolean = false; //是否编程模式(控制样式)
  isAudioPlay: boolean = false; //是否正在播放音频文件（控制切题时弹窗）
  isUploading: boolean = false;
  loading: boolean = false; //题干详情的loading
  answerLoading: boolean = false; //提交答案的loading
  isHave5Min: boolean = false; //倒计时五分钟出现提示

  orderList: SubjectType.SubjectOrder[] = []; //答题卡列表
  curExam: SubjectType.Subject = {} as SubjectType.Subject; //当前题目详情
  nextSubject: SubjectType.Subject = {} as SubjectType.Subject;
  audioDetails: SubjectType.AudioDetail[] = []; // 如果是听力题，当前听力题详情
  subjectIdEnumAnswer: Record<string, any> = {}; // 题目号码与答案的映射
  currentId: string = '';
  answerPicEnum: Record<string, string[]> = {}; // 问答题上传答案图片
  curLanguage: string = ''; //编程题当前的语言,主要是让组件外知道当前语言
  preAnswer: any = '';

  constructor() {
    makeAutoObservable(this);
    // makeLoggable(this);
  }

  removeOrderList() {
    this.orderList = [];
  }

  setData({ key, value }: { key: keyof ExamStore; value: any }) {
    // @ts-ignore
    this[key] = value;
  }

  setAnswer(id, value) {
    this.subjectIdEnumAnswer[id] = value;
  }

  setAnswerPic(id: string, value: string[]) {
    this.answerPicEnum[id] = value;
  }

  // 服务端数据
  hydrate = (data) => {
    if (!data) return;
    Object.entries(data).forEach(([key, value]) => {
      this[key] = value;
    });
  };

  get currentAnswer() {
    return this.subjectIdEnumAnswer[this.currentId] || '';
  }

  //根据题目类型排序题目
  get filterOrderList() {
    const obj = {};
    this.orderList.forEach((item, index) => {
      item['index'] = index;
      const type = item.type;
      if (obj[type]) {
        obj[type].push(item);
      } else {
        obj[type] = [item];
      }
    });
    return obj;
  }

  //题目id与顺序映射
  get idIndexEnum() {
    const obj = {};
    this.orderList.forEach((item, index) => {
      obj[index + 1] = item.id;
    });
    return obj;
  }

  fetchOrderList = async ({ exam_id }) => {
    try {
      const { data } = await getOrderList({ exam_id });
      runInAction(() => {
        this.orderList = data!.subject_order;
      });
      return data;
    } catch (e) {
      throw e;
    }
  };

  fetchCurExam = async ({ subject_id, exam_id }) => {
    try {
      const { data, status, msg } = await getExamOrder({ subject_id, exam_id });
      if (!data || msg || status !== 'success') return;
      runInAction(() => {
        this.curExam = data.subject;
      });
      return { subject: data?.subject };
    } catch (e) {
      throw e;
    }
  };

  fetchSubject = async ({
    subject_id,
    exam_id,
    noLoading,
  }): Promise<{
    subject: SubjectType.Subject;
    subject_order: SubjectType.SubjectOrder[] | undefined;
  }> => {
    if (!noLoading) this.loading = true;
    try {
      const promise1 = getOrderList({ exam_id });
      const promise2 = getExamOrder({ subject_id, exam_id });

      const [{ data: listData }, { data, status, msg }] = await Promise.all([promise1, promise2]);
      if (!data || msg || status !== 'success') return message.warning(msg);
      runInAction(() => {
        if (data) {
          this.orderList = listData?.subject_order || [];
          this.curExam = data!.subject;
        }
        this.loading = false;
      });
      return { subject: data?.subject, subject_order: listData?.subject_order };
    } catch (e) {
      this.loading = false;
      throw e;
    }
  };
}

export default ExamStore;
